import * as validators from '../../../../constants/validators';

export const config = {
  email: validators.email,
};
